/** @format */

import { reducerDebug } from '../../core/debug';

export type prefixesReducersType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const prefixesConstants = {
    LIST: 'prefixes_list',
    ITEM: 'prefixes_item',
    EDIT: 'prefixes_edit',
    DELETE: 'prefixes_delete',
    MANAGE: 'prefixes_manage',
    ADD: 'prefixes_add',
};

export function prefixesReducers(state = {}, action: prefixesReducersType): object {
    reducerDebug('Prefixes reducer: ' + action.type);
    switch (action.type) {
        case prefixesConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case prefixesConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case prefixesConstants.ADD:
        case prefixesConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case prefixesConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        default:
            return state;
    }
}
